import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track13ARed = ({ state, workState, onLabelClick }) => (
	<g id="Track13ARed" transform="translate(1823.000000, 1146.000000)" className="track">
		<g id="line" transform="translate(0.000000, 0.933594)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M32.8693383,307.375914 L41.0935428,273.867832 C47.1446288,249.213742 62.3457045,227.783788 83.6140546,213.923878 L88.4367781,210.781062 C110.409959,196.461835 119.026711,168.495812 108.92271,144.293124 L80.1335576,75.3328311 L80.1335576,75.3328311"/>
			<TrackArrow
				transform="translate(29.469419, 320.736579) rotate(-254.000000) translate(-29.469419, -320.736579) "
				points="33.4694191 328.736579 25.4694191 320.736579 33.4694191 312.736579"/>
			<path
				d="M0,353.920252 C5.24261568,359.229096 13.7962643,359.282785 19.1051089,354.04017 C20.8749128,352.292444 22.1278592,350.090045 22.7258688,347.675685 L29.9952378,318.326867 L29.9952378,318.326867"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track13ARed')}
			coords="86.000000, 108.000000"
			text="13A"
			textCoordsX="7.47363281"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>
);

Track13ARed.propTypes = trackPropTypes;

export default Track13ARed;
